import BootcampContainer from './bootcamp_container';

const Bootcamp = BootcampContainer;
export default Bootcamp;
